import React, { FC, useState } from 'react';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import logoutIcon from 'assets/icons/logout-icon.svg';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { handleApiError } from 'utils/functions';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  id: string;
  handleDelete: () => void;
};

interface ArchivePostModalFooterProps {
  onCancel: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const ArchivePostModalFooter: FC<ArchivePostModalFooterProps> = ({
  onCancel,
  onConfirm,
  loading
}) => (
  <div className='flex gap-2'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      onClick={onConfirm}
      loading={loading}>
      Confirm
    </Button>
  </div>
);
const ArchivePostPrompt = ({ isOpen, onClose, id, handleDelete }: Props) => {
  const [loading, setLoading] = useState(false);

  const confirmDelete = async () => {
    setLoading(true);
    try {
      const res = await apiService.delete(`internal/marketing/explore-posts/${id}`, {
        isInternal: true
      });
      if (res.status === 200) {
        toast(<ToastMessage type='success' message={res.data.message} />);
        handleDelete();
        onClose();
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <LocalModal
      isOpen={isOpen}
      onRequestClose={onClose}
      title={'Archive Post'}
      contentClassName='!max-w-[450px]'
      footer={
        <ArchivePostModalFooter onCancel={onClose} onConfirm={confirmDelete} loading={loading} />
      }>
      <div className='flex flex-col justify-center items-center'>
        <img src={logoutIcon} className='mx-auto mb-5 mt-4' />
        <p className='text-[#2E3031] text-center'>Are you sure you want to archive this post?</p>
      </div>
    </LocalModal>
  );
};

export default ArchivePostPrompt;
